import axios, { type AxiosError, type AxiosInstance, type AxiosResponse } from 'axios';

import { type ApiErrorResponse, type ApiResponse } from 'types';

export const axiosInstance: AxiosInstance = axios.create({
  baseURL: config.api_url,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

axiosInstance.interceptors.response.use(
  (response: AxiosResponse<ApiResponse>): AxiosResponse<ApiResponse> => {
    return response;
  },
  (error: AxiosError<ApiErrorResponse>): Promise<AxiosError> => {
    const customMessage = error?.response?.data?.error?.message || 'Unknown error occurred';
    const statusCode = error.response?.status;

    return Promise.reject({
      ...error,
      message: customMessage,
      code: statusCode,
    });
  }
);
